import AsyncState, { createAsyncStateReducer } from "react-async-stateful";

import * as ReduxUtils from "../../../lib/util/ReduxUtils";

import * as InviteDriverFormActions from "./InviteDriversForm.action";
import { Invite, UserLevelName } from "../../../lib/types/UserTypes";

export const INVITE_LIMIT = 1000;

export const INVITE_STEP_START = "step1";
export const INVITE_STEP_INPUT = "step2";
export const INVITE_STEP_NAMES = "names";
export const INVITE_STEP_GROUPS = "groups";
export const INVITE_STEP_SUCCESS = "success";

export const INVITE_FORM_TYPE_MANUAL = "manual";
export const INVITE_FORM_TYPE_UPLOAD = "upload";

export interface InviteDriverInfo {
	email: string;
	group: string | null;
	providedGroup?: string | null;
	firstName?: string;
	lastName?: string;
	level?: UserLevelName;
}

export interface InviteDriverValidation extends InviteDriverInfo {
	valid: boolean;
	managerOnly: boolean;
	exists: boolean;
	reminder: boolean;
	providedGroup: string | null;
	firstName?: string;
	lastName?: string;
}

export interface InviteDriversState {
	drivers: InviteDriverValidation[];
	managers: InviteDriverValidation[];
	invalid: InviteDriverValidation[];
	duplicates: string[];
}

export interface InviteDriversResult {
	success: Invite[];
	failed: Invite[];
}

export interface InviteDriversFormReducerState {
	drivers: AsyncState<InviteDriversState>;
	invites: AsyncState<InviteDriversResult>;
}

const initialState: InviteDriversFormReducerState = {
	drivers: AsyncState.create(),
	invites: AsyncState.create(),
};

export default ReduxUtils.composeReducer(initialState, [
	createAsyncStateReducer<InviteDriversFormReducerState>({
		drivers: InviteDriverFormActions.setDrivers.type,
		invites: InviteDriverFormActions.sendInvites.type,
	}),
	ReduxUtils.createReducerMap({
		[InviteDriverFormActions.updateDrivers.type]: (state, action) => ({
			...state,
			drivers: {
				...state.drivers,
				value: action.payload,
			},
		}),
		[InviteDriverFormActions.resetForm.type]: (state, action) => initialState,
	}),
]);
